import React, { useRef, useState } from 'react';
import { Check, Paperclip, Loader2, FileDown } from 'lucide-react';
import { toast } from 'sonner';
import { api, errMsg, downloadFile } from '../api';

export function ChecklistItem({ k, text, state, save, tripId }) {
  const s = state || {};
  const [note, setNote] = useState(s.note || '');
  const [busy, setBusy] = useState(false);
  const input = useRef(null);
  const put = (patch) => save(k, { done: !!s.done, note, date: s.date || null, ...patch });
  const upload = async (e) => {
    const f = e.target.files?.[0]; if (!f) return;
    setBusy(true);
    const fd = new FormData(); fd.append('key', k); fd.append('file', f); if (tripId) fd.append('trip_id', tripId);
    try { await api.post('/travel/files', fd); toast.success('Documento caricato'); save(k, null); } catch (err) { toast.error(errMsg(err)); } finally { setBusy(false); e.target.value = ''; }
  };
  return (
    <div className="py-4 border-t border-[#1F242C] first:border-0" data-testid={`check-item-${k}`}>
      <div className="flex gap-3 items-start">
        <button onClick={() => put({ done: !s.done, date: !s.done ? new Date().toISOString().slice(0, 10) : s.date })} aria-pressed={!!s.done}
          className={`w-6 h-6 mt-0.5 shrink-0 rounded-sm border grid place-items-center transition-colors ${s.done ? 'bg-[#2E9E6A] border-[#2E9E6A] text-white' : 'border-[#3A3F47]'}`} data-testid={`check-toggle-${k}`}>{s.done && <Check size={14} />}</button>
        <div className="flex-1 min-w-0">
          <p className={`text-sm ${s.done ? 'text-[#8A8F97]' : 'text-[#F2F2F2]'}`}>{text}</p>
          {s.done && s.date && <p className="text-[11px] text-[#5FC18F] mt-0.5">Completata il {new Date(s.date).toLocaleDateString('it-IT')}</p>}
          <div className="flex flex-wrap gap-2 mt-2">
            <input value={note} onChange={(e) => setNote(e.target.value)} onBlur={() => note !== (s.note || '') && put({})} placeholder="Note, responsabile, riferimenti…"
              className="flex-1 min-w-[200px] h-8 px-3 text-xs bg-transparent border border-[#1F242C] rounded-sm text-[#E5E5E5] outline-none focus:border-[#D4AF37]" data-testid={`check-note-${k}`} />
            <button onClick={() => input.current?.click()} disabled={busy} className="h-8 px-3 text-xs border border-[#1F242C] rounded-sm text-[#A3A3A3] hover:text-[#D4AF37] inline-flex items-center gap-1.5" data-testid={`check-upload-${k}`}>
              {busy ? <Loader2 size={13} className="animate-spin" /> : <Paperclip size={13} />}Allega documento</button>
            <input ref={input} type="file" className="hidden" onChange={upload} data-testid={`check-file-${k}`} />
          </div>
          {(s.files || []).map((f) => (
            <button key={f.id} onClick={() => downloadFile(`/travel/files/${f.id}`, f.name).catch((e) => toast.error(errMsg(e)))} className="mt-1.5 mr-3 text-xs text-[#D4AF37] hover:underline inline-flex items-center gap-1" data-testid={`check-filelink-${f.id}`}><FileDown size={12} />{f.name}</button>
          ))}
        </div>
      </div>
    </div>
  );
}

export function Progress({ p, testid }) {
  const pct = p.total ? Math.round((p.done / p.total) * 100) : 0;
  return (
    <div className="flex items-center gap-3" data-testid={testid}>
      <div className="h-1.5 flex-1 bg-[#1F242C] rounded"><div className="h-full rounded bg-[#2E9E6A] transition-[width] duration-500" style={{ width: `${pct}%` }} /></div>
      <span className="text-xs text-[#A3A3A3] font-mono">{p.done}/{p.total}</span>
    </div>
  );
}
